import script from "./custFlexusMan.vue?vue&type=script&setup=true&lang=ts"
export * from "./custFlexusMan.vue?vue&type=script&setup=true&lang=ts"

import "./custFlexusMan.vue?vue&type=style&index=0&id=21538970&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21538970"]])

export default __exports__